import React, { useEffect, useRef, useState } from 'react'
import { postAPI } from '../../app/api'
import { setStore, store } from '../../app/store'
import LoginImg from "../../theme/assets/img/Two-factor-authentication-bro.svg"
import LogoImg from "../../theme/assets/img/wt-logo.png"
import { useParams } from 'react-router-dom'
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function EmailVerification() {
  const { server_id, user_type, username, email_otp } = useParams();
  const [IsBTNClicked, setIsBTNClicked] = useState(false);

  const requestPhoneOTP = async () => {
    try {
      const response = await postAPI("/super_admin/architecture/auth_handle/verification-email-otp", {server_id: server_id, user_type: user_type, username: username, otp: email_otp});
      // console.log(response)
      if (response?.data?.res == 1) {
        window.location.href = '/Success'
        setIsBTNClicked(false);
        toast.success(`Great Job ! ${response?.data?.msg} .`);
      } else {
        setIsBTNClicked(false);
        toast.error(`Sorry ! ${response?.data?.msg}`);
      }
    } catch (e) {
      setIsBTNClicked(false);
      toast.error('Sorry ! Something Wrong. Please try again.');
      // console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  useEffect(() => {
    requestPhoneOTP()
  }, [server_id, user_type, username, email_otp])

  return (
    <>

      <div class="main-wrapper log-wrap LoginPage">
        <div class="row">
          <div class="col-md-6 login-bg">
            <div class="welcome-login">
              <div class="login-banner"><img class="img-fluid" src={LoginImg} alt="Logo" width="366" height="366" /></div>
              <div class="text-center mentor-course">
                <h2>Welcome to <br />Architecture</h2>
                <p>Your email id will be varified sortly.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 login-wrap-bg">
            <div class="login-wrapper">
              <div class="loginbox">
                <div class="img-logo"><img class="img-fluid" src={LogoImg} alt="Logo" />
                </div>
                <h1>Verifing your email id ...</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
    </>
  )
}
